import styled from "styled-components";

export const ProfileMessagesDefaultBox = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 1rem;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        margin: 1rem 0;
        padding: 0;
    }
`;
